<template>
	<brace
		style="height:90vh;width:100vw"
		class="kbet-editor"
		:mode="'json'"
		@code-change="onEditorCodeChange"
		@setHandler="
			h => {
				editorHandler = h;
			}
		"
	/>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {},
	created() {},
	data() {
		return {
			editorCode: '',
			editorHandler: false,
		};
	},
	methods: {
		...mapActions('fileMeta', []),
		...mapMutations(['openSnackbar']),
		...mapMutations('fileMeta', ['closeFileMetaDialog']),
		// ...mapMutations("fileMeta", ["closeFileMetaDialog"]),
		onEditorCodeChange(code) {
			this.editorCode = code;
		},
	},
	computed: {
		...mapGetters(['getSelectedDates']),
		...mapGetters('fileMeta', ['selectedFileMeta']),
	},
	mounted() {
		// console.log(this.selectedFileMeta)
		this.editorHandler.setValue(JSON.stringify(this.selectedFileMeta, null, 2));
	},
};
</script>

<style lang="scss" scoped></style>
